var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "sidebar", attrs: { id: "sidebar" } },
      [
        _c(
          "vue-custom-scrollbar",
          {
            staticClass: "scroll-area",
            attrs: { settings: _vm.settings },
            on: { "ps-scroll-x": _vm.scrollHanle }
          },
          [
            _c("div", { staticClass: "sidebar-menu" }, [
              _c("ul", [
                _c(
                  "li",
                  { staticClass: "index" },
                  [
                    _c("router-link", { attrs: { to: "/index" } }, [
                      _c("i", { staticClass: "la la-home" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Back to Home")])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("li", { staticClass: "menu-title" }, [_vm._v("Settings")]),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "settings",
                    class: { active: _vm.currentpage === "settings" }
                  },
                  [
                    _c("router-link", { attrs: { to: "/settings" } }, [
                      _c("i", { staticClass: "la la-building" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Profile")])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "localization",
                    class: { active: _vm.currentpage === "localization" }
                  },
                  [
                    _c("router-link", { attrs: { to: "/localization" } }, [
                      _c("i", { staticClass: "la la-clock-o" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Localization")])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "changepassword",
                    class: { active: _vm.currentpage === "changepassword" }
                  },
                  [
                    _c("router-link", { attrs: { to: "/changepassword" } }, [
                      _c("i", { staticClass: "la la-lock" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Change Password")])
                    ])
                  ],
                  1
                )
              ])
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0793451d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0793451d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/SidebarPromotion.vue
// module id = null
// module chunks = 